// @flow

import { type OutgoingPayment } from './types';
import { type IncomingPayment, normalizeIncomingPayment } from '@tectonics/prs/incoming-payment';
import { PlaceOrderError } from './place-order-error';
import { getPaymentType } from './get-payment-type';

export async function placeOrder(outgoingPayment: OutgoingPayment, localTenacy?: string): Promise<IncomingPayment> {
  assertOutgoingCreditCardPayment(outgoingPayment);

  const placeOrderUrl = `${ENV_CONSTANTS.ANDES_BASE_URL}/payments`;

  const headers = new Headers();
  headers.append('Content-Type', 'application/json');

  if (localTenacy) {
    headers.append('X-Custom-EBX-Platform', localTenacy);
  }

  const response = await fetch(placeOrderUrl, {
    method: 'POST',
    headers,
    body: JSON.stringify(outgoingPayment),
  });

  if (response.status > 499) {
    await delay(nextDelayTime());
  }

  const responseJson = await response.json();

  if (responseJson.status === 'ERROR') {
    throw new PlaceOrderError({
      code: responseJson.code,
      message: responseJson.error,
    });
  }

  if (responseJson.status !== 'SUCCESS') throw responseJson;

  const rawIncomingPayment = responseJson.payment;
  return normalizeIncomingPayment(rawIncomingPayment);
}

function assertOutgoingCreditCardPayment(outgoingPayment: OutgoingPayment) {
  if (!outgoingPayment.card || getPaymentType(outgoingPayment) === 'google') {
    return;
  }

  const { card } = outgoingPayment;

  const placeOrderError = new PlaceOrderError({
    code: '',
    message: 'Erro ao validar dados do cartão',
  });

  if (!card.token || !card.card_cvv) {
    throw placeOrderError;
  }

  if (Object.hasOwnProperty.call(card, 'card_number')) {
    throw placeOrderError;
  }
}

let delayTime = 0;

export function resetDelayTime() {
  delayTime = 0;
}

export function nextDelayTime(): number {
  delayTime = delayTime ? delayTime * 3 : 10000;
  return delayTime;
}

function delay(time: number): Promise<void> {
  return new Promise(resolve => {
    setTimeout(resolve, time);
  });
}
